import React from 'react';

function SidebarPromo({ onOpenPlans }) {
  return (
    <div className="mp-sidebar-promo">
      <p className="mp-sidebar-promo__text">Desbloqueie todos os recursos de IA por 7 dias.</p>
      <button type="button" className="mp-sidebar-promo__cta" onClick={onOpenPlans}>
        Testar por R$0
      </button>
    </div>
  );
}

export default SidebarPromo;
